import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import * as cssVariable from 'cssVariables';
import { injectStyles } from 'injectStyles';

import { BreadcrumbsSchema, PageTypeSchema } from 'components/Schema';
import PageHeader from 'components/PageHeader';
import PageContent from 'components/PageContent';
import LoadingPage from 'components/pages/status/LoadingPage';
import NotFoundPage from 'components/pages/status/NotFoundPage';
import FaqCategoryList from 'components/FaqCategoryList';
import FaqAnswer from 'components/FaqAnswer';
import FaqQuestions from 'components/FaqQuestions';
import { faqContentTypes, FAQ_LANDING_SLUG } from 'actions/actions-const';

import { VRAGEN_PAGE_TITLE } from 'globalConst/const';
import { SCHEMA_PAGE_TYPE } from 'globalConst/schema-const';

class QuestionPage extends PureComponent {
  static defaultProps = {
    answerContent: null,
    hidePlayer: false,
    hideSearch: false,
    isError: false,
    isLoading: false,
    question: null,
    relatedQuestions: null,
    urlMatch: {
      params: {},
    },
  };

  static propTypes = {
    answerContent: PropTypes.array,
    classes: PropTypes.object.isRequired,
    forceMiniPlayerState: PropTypes.func.isRequired,
    hidePlayer: PropTypes.bool,
    hideSearch: PropTypes.bool,
    urlMatch: PropTypes.object,
    question: PropTypes.string,
    relatedQuestions: PropTypes.array,
    isError: PropTypes.bool,
    isLoading: PropTypes.bool,
    setSearchHidden: PropTypes.func.isRequired,
    slug: PropTypes.string.isRequired,
  };

  componentDidUpdate() {
    const { hidePlayer, hideSearch } = this.props;

    this.props.forceMiniPlayerState(hidePlayer);
    this.props.setSearchHidden(hideSearch);
  }

  componentWillUnmount() {
    const { hidePlayer, hideSearch } = this.props;
    if (hidePlayer) {
      this.props.forceMiniPlayerState(false);
    }
    if (hideSearch) {
      this.props.setSearchHidden(false);
    }
  }

  render() {
    const { answerContent, classes, urlMatch, isLoading, isError, question, relatedQuestions, slug } = this.props;

    const { categorySlug } = urlMatch.params;

    if (isLoading) {
      return <LoadingPage />;
    }

    if (isError) {
      return <NotFoundPage />;
    }

    return (
      <div className={classes.container}>
        <PageTypeSchema type={SCHEMA_PAGE_TYPE.FAQ_PAGE} question={question} answer={answerContent} />
        <PageHeader title={question} />
        <BreadcrumbsSchema level2={VRAGEN_PAGE_TITLE} level3={categorySlug.split('-').join(' ')} level4={question} />
        <PageContent>
          <section className={classes.section}>
            <FaqAnswer answerContent={answerContent} questionSlug={slug} question={question} />
          </section>
          {relatedQuestions && (
            <section className={classes.section}>
              <h3>Gerelateerde vragen</h3>
              <FaqQuestions categorySlug={categorySlug} questions={relatedQuestions} />
            </section>
          )}
          <FaqCategoryList current={categorySlug} contentType={faqContentTypes.LANDING} slug={FAQ_LANDING_SLUG} />
        </PageContent>
      </div>
    );
  }
}

const styles = {
  container: {
    margin: 'auto',
    maxWidth: 780,

    '& p': {
      fontSize: 18,
      lineHeight: 1.33,
      color: cssVariable.grey500,
    },
  },

  list: {
    listStyle: 'none',
    margin: 0,
    padding: 0,

    '& li': {
      marginBottom: 15,

      '&:last-of-type': {
        marginBottom: 0,
      },
      '& a': {
        color: cssVariable.grey500,
      },
    },
  },
  section: {
    marginBottom: 40,
    paddingBottom: 40,
    boxShadow: 'inset 0 -1px 0 0 rgba(0,0,0,.1)',
  },

  btnDesign: {
    padding: '0 20px',
    height: 40,
    marginRight: 10,
    lineHeight: '38px',
    textAlign: 'center',
    border: '1px solid',
    borderColor: cssVariable.transparentLightmode030,
    color: cssVariable.grey600,
    textDecoration: 'none',
    cursor: 'pointer',
    display: 'inline-block',

    '&:focus, &:active': {
      border: `1px solid ${cssVariable.transparentLightmode030}`,
    },
  },
};

export default injectStyles(styles)(QuestionPage);
